import * as req from 'api/actions';
import * as c from './constant';

export const getTransactionList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/wallet/mobile_load',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/wallet/mobile_load/${id}`,
    payload,
    callback
  );
